export const dateFormat = 'D.M.YYYY'
export const dateTimeFormat = 'D.M.YYYY HH:mm'